<template>
  <div class="login-page">
    <div class="login-card">
      <img class="login-logo" src="/brand-logo.png?v=20261022b" alt="舞蹈花园 Logo">
      <h1>舞蹈花园·芭蕾</h1><p>成人芭蕾门店管理平台</p>
      <el-form :model="form" @submit.native.prevent="submit">
        <el-form-item><el-input v-model.trim="form.username" placeholder="管理员用户名" autocomplete="username" prefix-icon="el-icon-user" /></el-form-item>
        <el-form-item><el-input v-model="form.password" type="password" placeholder="密码" autocomplete="current-password" prefix-icon="el-icon-lock" show-password /></el-form-item>
        <el-button type="primary" native-type="submit" :loading="loading" class="login-button">登录管理平台</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import { login } from '../api'
export default {
  data: () => ({ form: { username: '', password: '' }, loading: false }),
  methods: {
    async submit () {
      if (!this.form.username || !this.form.password) return this.$message.warning('请输入用户名和密码')
      this.loading = true
      try {
        const result = await login(this.form)
        localStorage.setItem('admin_token', result.token)
        this.$router.replace('/dashboard')
      } catch (e) { this.$message.error(e.message) } finally { this.loading = false }
    }
  }
}
</script>
<style scoped>
.login-page { min-height: 100vh; display: grid; place-items: center; background: #f7f5f1; }
.login-card { width: 400px; background: #fff; border: 1px solid #e8e4dd; border-radius: 16px; padding: 45px 42px; text-align: center; box-shadow: 0 24px 65px rgba(39,51,52,.08); }
.login-logo { width: 88px; height: 70px; object-fit: contain; display: block; margin: -8px auto -3px; }
h1 { font-family: "Songti SC", "STSong", serif; font-weight: 500; letter-spacing: 5px; margin: 20px 0 6px; }
p { color: #89938f; font-size: 12px; margin: 0 0 31px; }
.login-button { width: 100%; margin-top: 5px; }
</style>
